import { type CSSProperties, useRef } from 'react'

import { SwipeableList, SwipeableListItem } from 'react-swipeable-list'

import { Actions } from '@/modules/chatting/ui/sidebar/chat-item/Actions.tsx'

import { ChatItem, type ChatItemProps } from '.'

import 'react-swipeable-list/dist/styles.css'

type Props = ChatItemProps & {
  style: CSSProperties
}

export const SwipeableChatItemWithActions = ({
  style,
  ...chatItemProps
}: Props) => {
  const isSwiped = useRef(false)

  const handleClick = () => {
    if (!isSwiped.current) {
      chatItemProps.onClick()
    }
    isSwiped.current = false
  }

  return (
    <SwipeableList
      threshold={0.3}
      style={style}
      className="select-none"
    >
      <SwipeableListItem
        trailingActions={<Actions chatId={chatItemProps.chatId} />}
        onSwipeProgress={() => {
          isSwiped.current = true
        }}
      >
        <ChatItem {...{ ...chatItemProps, onClick: handleClick }} />
      </SwipeableListItem>
    </SwipeableList>
  )
}
